export default {
  setSettings(state, settings) {
    state.stimuli = Object.assign({}, settings);
  },
  setSessions(state, sessions) {
    state.sessions = Object.assign({}, sessions);
  },
  setAuditor(state, object) {
    state.auditor = object;
  },
  setAssignee(state, object) {
    state.assignee = object;
  },
  setStartedAt(state, value) {
    state.startedAt = value;
  },
  setFinishedAt(state, value) {
    state.finishedAt = value;
  },
  setIsSaved(state, value) {
    state.isSaved = value;
  },
  setUuid(state, uuid) {
    state.uuid = uuid;
  },
};


// WEBPACK FOOTER //
// ./src/modules/randomRotation/vuex/mutations.js